import React, { useRef, useEffect, useState } from 'react'
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Grid, Box, ButtonGroup, Button, Snackbar, IconButton } from '@material-ui/core'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'
import UpdatePage from '../components/UpdatePage'
import HeaderImg from '../components/HeaderImg'
import contact_ph from '../images/contact_ph.jpg'
import contact_mobile from '../images/contact_small.jpg'
import contact_desktop from '../images/contact_med.jpg'
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import DraftsIcon from '@material-ui/icons/Drafts';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import RoomIcon from '@material-ui/icons/Room';
import CloseIcon from '@material-ui/icons/Close';
import CustomTextField from '../components/CustomTextField'
import { formInitState } from '../components/formHelper'

const useStyles = makeStyles((theme) => ({
    submitBtn: {
        marginRight: theme.spacing(2)
    },
    infoSnack: {
        '& div': {
            background: '#4B71C0'
        }
    }
}))

const CustomButton = withStyles((theme) => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'left'
        }
    },
}))(Button);

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default function About() {
    const classes = useStyles();
    const [formState, changeFormValues] = useState(formInitState)
    const prevFormState = usePrevious(formState)
    const [isSnackOpen, setSnackState] = useState(false)
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up('md'));

    function updateFormValues(event) {
        const { name, value } = event.target
        changeFormValues({
            ...formState,
            [name]: {
                ...formState[name],
                value,
            }
        })
    }

    function validateInput(event) {
        const { name, value } = event.target
        if (prevFormState && value !== prevFormState[name]['value'] && value !== "") {
            const errorVal = !formState[name]['regex'].test(value)
            changeFormValues({
                ...formState,
                [name]: {
                    ...formState[name],
                    error: errorVal
                }
            })
        }
        else if (value === "") {
            changeFormValues({
                ...formState,
                [name]: {
                    ...formState[name],
                    error: false
                }
            })
        }
    }

    const encode = (data) => {
        return Object.keys(data)
            .filter(key => key !== 'isSubmitted' && key !== 'submitBtnVal')
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
    }

    function submitForm(event) {
        event.preventDefault()
        changeFormValues({
            ...formState,
            isSubmitted: true,
            submitBtnVal: `Submitting`
        })
        const formData = Object.assign({}, formState)
        Object.keys(formData).map((key, index) =>
            formData[key] = formData[key]['value'])
        fetch('/?ts=' + Math.floor(Date.now() / 1000), {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            cache: 'no-cache',
            body: encode({ "form-name": "contact-us", ...formData })
        }).then(resp => {
            if (resp.ok) {
                changeFormValues({
                    ...formState,
                    isSubmitted: true,
                    submitBtnVal: "Submitted"
                }); setSnackState(true)
            }
            else {
                changeFormValues({
                    ...formState,
                    isSubmitted: false,
                    submitBtnVal: "Submit"
                })
            }
        })
    }

    return (
        <Grid container spacing={2}>
            <ScrollToTopOnMount />
            <UpdatePage title='RQuaL Solution -  Contact us with your queries ' />
            <Grid item xs={12}>
                <HeaderImg ph={contact_ph} srcMobile={contact_mobile} srcDesktop={contact_desktop} />
            </Grid>
            <Grid item xs={12} component={Box} textAlign={{ xs: 'center', sm: 'left' }}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }} mb={2}>
                    Reach us via our Social Channels
                </Box>
                <ButtonGroup variant="text" {...(isMobile && { orientation: 'vertical' })}>
                    <CustomButton
                        size="large"
                        startIcon={<LinkedInIcon />}
                        onClick={e => window.open('https://www.linkedin.com/company/rqual-solutions')}
                    >
                        /RQuaL-Solutions
                    </CustomButton>
                    <CustomButton
                        size="large"
                        startIcon={<TwitterIcon />}
                        onClick={e => window.open('http://twitter.com/@RQuaLSolutions')}
                    >
                        @RQuaLSolutions
                    </CustomButton>
                    <CustomButton
                        size="large"
                        startIcon={<WhatsAppIcon />}
                        onClick={e => window.open('https://wa.me/+919317553000')}
                    >
                        +91 93175 53000
                    </CustomButton>
                    <CustomButton
                        size="large"
                        startIcon={<DraftsIcon />}
                        onClick={e => window.open('mailto:info@rqual.com')}
                    >
                        info@rqual.com
                    </CustomButton>
                </ButtonGroup>
            </Grid>
            <Grid item xs={12} component={Box} textAlign={{ xs: 'center', sm: 'left' }}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }} mb={2}>
                    Reach us via Post or your Car
                </Box>
                <CustomButton
                    size="large"
                    startIcon={<RoomIcon />}
                    onClick={e => window.open('https://goo.gl/maps/Q59zS2SsqtACK54r9')}
                >
                    25-B, Sunny Enclave, Mohali, Punjab (IN)
                    </CustomButton>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }} textAlign={{ xs: 'center', sm: 'left' }}>
                    Connect with us using form
                </Box>
            </Grid>
            <Grid item container spacing={3} component="form" onSubmit={(e) => submitForm(e)}>
                <Grid item xs={12} sm={6} md={3}>
                    <CustomTextField
                        label="First Name"
                        type="text"
                        autoComplete="given-name"
                        required
                        name="firstName"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <CustomTextField
                        label="Last Name"
                        type="text"
                        autoComplete="family-name"
                        required
                        name="lastName"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomTextField
                        label="Email Address"
                        type="email"
                        autoComplete="email"
                        required
                        fullWidth
                        name="email"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <CustomTextField
                        label="Phone Number"
                        type="tel"
                        autoComplete="tel"
                        name="phone"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomTextField
                        label="Company Name"
                        type="text"
                        autoComplete="organisation"
                        name="company"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomTextField
                        label="Job Title"
                        type="text"
                        autoComplete="organisation-title"
                        name="jobTitle"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomTextField
                        label="How did you hear about us?"
                        type="text"
                        required
                        name="referral"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CustomTextField
                        label="Your Message"
                        type="text"
                        required
                        multiline
                        rows={3}
                        name="msg"
                        formState={formState}
                        onBlur={(e) => validateInput(e)}
                        onChange={(e) => updateFormValues(e)}
                    />
                </Grid>
                <Grid item xs={12} component={Box} textAlign={{ xs: 'center', md: 'left' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        type="submit"
                        className={classes.submitBtn}
                        disabled={formState.isSubmitted}
                    >
                        {formState.submitBtnVal}
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        type="reset"
                        onClick={(e) => { e.preventDefault(); changeFormValues(formInitState) }}
                    >
                        Reset
                    </Button>
                    <Snackbar
                        className={classes.infoSnack}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        open={isSnackOpen}
                        autoHideDuration={5000}
                        onClose={(e, r) => r === 'clickaway' ? null : setSnackState(false)}
                        message="Query has been submitted successfully!"
                        action={
                            <IconButton size="small" aria-label="close" color="inherit"
                                onClick={(e, r) => r === 'clickaway' ? null : setSnackState(false)}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}